import React from 'react';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import { cyberpunkColors } from './theme/cyberpunkTheme';

const Od = ({ od_rate }) => {
  return (
    <Card
      sx={{
        background: 'linear-gradient(145deg, #1a1a24, #0d0d14)',
        border: '1px solid rgba(0, 255, 255, 0.3)',
        borderRadius: 2,
        transition: 'all 0.3s ease',
        height: '100%',
        '&:hover': {
          borderColor: cyberpunkColors.neonCyan,
          boxShadow: '0 0 25px rgba(0, 255, 255, 0.2)',
        },
      }}
    >
      <CardContent>
        <Typography
          sx={{
            fontSize: 11,
            fontFamily: '"Orbitron", sans-serif',
            color: cyberpunkColors.textSecondary,
            textTransform: 'uppercase',
            letterSpacing: '0.1em',
            mb: 1,
          }}
        >
          On-Demand Rate
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5 }}>
          <Typography
            variant="h4"
            sx={{
              fontFamily: '"Orbitron", sans-serif',
              fontWeight: 700,
              color: cyberpunkColors.neonCyan,
              textShadow: '0 0 10px rgba(0, 255, 255, 0.5)',
            }}
          >
            ${od_rate}
          </Typography>
          <Typography
            sx={{
              fontSize: 14,
              color: cyberpunkColors.textSecondary,
              fontFamily: '"Rajdhani", sans-serif',
            }}
          >
            /hr
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default Od;
